

const menuData = [
    /*
    {
        key: "item0011",
        text: "Ordenes de dispersión",
        percentage : { color: "success", text:"" },
        icon : { color: "info", component: "paid" },
        componentUrl: "/reportes/ordenesdedispersion",
        bgColor: "color3V",
        direction: "right"
    },
    */
    {
        key: "item0022",
        title: "Transacciones",
        text: "Ordenes de dispersión",
        percentage : { color: "success", text:"" },
        icon : { color: "info", component: "paid" },
        componentUrl: "/reportes/ordenes-de-dispersion",
        bgColor: "color6V",
        direction: "right"
    },
    {
        key: "creditos090525",
        title: "Créditos",
        text: "Creditos",
        percentage : { color: "success", text:"" },
        icon : { color: "info", component: "summarize" },
        componentUrl: "/reportes/creditos",
        bgColor: "color6V",
        direction: "right"
    },
];

export default menuData;